import { render, staticRenderFns } from "./eDocumentDetails.vue?vue&type=template&id=1b3aaeca&scoped=true"
import script from "./eDocumentDetails.vue?vue&type=script&lang=js"
export * from "./eDocumentDetails.vue?vue&type=script&lang=js"
import style0 from "./eDocumentDetails.vue?vue&type=style&index=0&id=1b3aaeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3aaeca",
  null
  
)

export default component.exports